'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');

function _interopNamespace(e) {
    if (e && e.__esModule) return e;
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function (k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function () {
                        return e[k];
                    }
                });
            }
        });
    }
    n['default'] = e;
    return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);

const Svg16 = (props) => (React__namespace.createElement("svg", Object.assign({ width: 16, height: 17, viewBox: "0 0 16 17", fill: "none" }, props),
    React__namespace.createElement("path", { d: "M1.35196 5.2918C0.933183 5.65186 0.885584 6.28324 1.24564 6.70201L6.50706 12.8214L6.53577 12.8549C6.68591 13.0297 6.85969 13.232 7.03103 13.3824C7.23459 13.561 7.56351 13.7845 8.02357 13.7845C8.48364 13.7845 8.81255 13.561 9.01612 13.3824C9.18747 13.232 9.36125 13.0297 9.51138 12.8549L9.5401 12.8214L14.7539 6.75747C15.114 6.3387 15.0664 5.70733 14.6476 5.34726C14.2289 4.9872 13.5975 5.03479 13.2374 5.45356L8.02359 11.5175L2.76217 5.39812C2.40211 4.97934 1.77074 4.93174 1.35196 5.2918Z", fill: props.fillColor, fillOpacity: 0.92 })));

exports.default = Svg16;
//# sourceMappingURL=16.js.map
